import tabStyles from './components/Tabs/PeachyTabs.module.css'

export {tabStyles}
